import { createSelector } from 'reselect';
import { RootState } from '../../store/store';
import { RefundDTO } from './types';

// Базовые селекторы для получения частей состояния `RefundState`
const refundsListSelector = (state: RootState) => state.refunds.list;
const currentRefundSelector = (state: RootState) => state.refunds.current;
const isLoadingSelector = (state: RootState) => state.refunds.isLoading;
const errorsSelector = (state: RootState) => state.refunds.errors;

// Создание селекторов

// Селектор для получения всех возвратов
export const selectAllRefunds = createSelector(refundsListSelector, refunds => refunds || []);

// Селектор для получения текущего возврата
export const selectCurrentRefund = createSelector(currentRefundSelector, refund => refund);

// Селекторы для статусов загрузки
export const selectIsLoadingRefundList = createSelector(
  isLoadingSelector,
  isLoading => isLoading.list,
);

export const selectIsLoadingCreateRefund = createSelector(
  isLoadingSelector,
  isLoading => isLoading.create,
);

export const selectIsLoadingRetrieveRefund = createSelector(
  isLoadingSelector,
  isLoading => isLoading.retrieve,
);

export const selectIsLoadingUploadAttachments = createSelector(
  isLoadingSelector,
  isLoading => isLoading.uploadAttachments,
);

// Селекторы для ошибок
export const selectRefundListError = createSelector(errorsSelector, errors => errors.list || '');

export const selectCreateRefundError = createSelector(
  errorsSelector,
  errors => errors.create || '',
);

export const selectRetrieveRefundError = createSelector(
  errorsSelector,
  errors => errors.retrieve || '',
);

export const selectUploadAttachmentsError = createSelector(
  errorsSelector,
  errors => errors.uploadAttachments || '',
);

// Селектор для получения вложений текущего возврата
export const selectCurrentRefundAttachments = createSelector(selectCurrentRefund, refund =>
  refund ? refund.attachments : [],
);

// Селектор для получения информации о товаре в текущем возврате
export const selectCurrentRefundOrderItem = createSelector(selectCurrentRefund, refund =>
  refund ? refund.order_item : null,
);

// Селектор для фильтрации возвратов по статусу, дате и поисковому запросу
export const selectFilteredRefunds = (
  status: number,
  startDate: Date | null,
  endDate: Date | null,
  searchTerm: string,
) =>
  createSelector(selectAllRefunds, refunds => {
    return refunds.filter((refund: RefundDTO) => {
      // Фильтрация по статусу
      const matchesStatus = status === 0 || refund.status === status;

      // Фильтрация по дате
      const createdAtDate = new Date(refund.created_at);
      const matchesStartDate = startDate ? createdAtDate >= startDate : true;
      const matchesEndDate = endDate ? createdAtDate <= endDate : true;

      // Фильтрация по поисковому запросу
      const matchesSearchTerm = refund.reason.toLowerCase().includes(searchTerm.toLowerCase());

      return matchesStatus && matchesStartDate && matchesEndDate && matchesSearchTerm;
    });
  });
